import { GoldDivider } from "./GoldDivider";

export function SectionTitle({ subtitle, title, light = false }) {
  return (
    <div className="section-title scroll-reveal">
      <p className="eyebrow">{subtitle}</p>
      <h2 className={light ? "section-title__heading section-title__heading--light" : "section-title__heading"}>
        {title}
      </h2>
      <GoldDivider />
    </div>
  );
}
